// Build identity, stamped at build time by the `define` block in
// vite.config.js. Consumers who vendor src/ and build with their own Vite
// config won't have those defines — `typeof` on an undeclared global is safe,
// so they get "dev" instead of a ReferenceError. Hosts that want a real stamp
// can copy the `define` block into their own config.
/* global __RPILOT_VERSION__, __RPILOT_BUILD_DATE__, __RPILOT_COMMIT_SHA__ */

export const BUILD_DATE =
  typeof __RPILOT_BUILD_DATE__ !== 'undefined' ? __RPILOT_BUILD_DATE__ : 'dev'
export const COMMIT_SHA =
  typeof __RPILOT_COMMIT_SHA__ !== 'undefined' ? __RPILOT_COMMIT_SHA__ : 'dev'
export const VERSION =
  typeof __RPILOT_VERSION__ !== 'undefined' ? __RPILOT_VERSION__ : 'dev'

export const buildInfo = Object.freeze({
  version: VERSION,
  buildDate: BUILD_DATE,
  commit: COMMIT_SHA,
})
